<template>
  <!-- <b-card-code :title="$t('user.mobile')"> -->
  <div>
    <b-form
      ref="form"
      :style="{ minHeight: trHeight }"
      class="repeater-form mt-0"
      @submit.prevent="repeateAgain"
    >
      <!-- :style="{ height: trHeight }" -->
      <!-- Row Loop -->
      <b-row v-for="(phone, index) in phones" :key="index" ref="row">
        <!-- Item Type -->
        <!-- Remove Button -->
        <b-col xl="2" lg="3" md="4" sm="6">
          <b-form-group
            :label="$t('address.type')"
            :label-for="`admission-phone-type${index}`"
            class="mb-0"
          >
            <my-v-select
                :key="phones[index].type"
              :id="`admission-phone-type${index}`"
              v-if="types"
              :translate="false"
              v-model="phones[index].type"
              :concat-label="['text']"
              :reduce-field="['value']"
              :options="types.length ? types : []"
              :multiple="false"
              :searchable="true"
              :filterable="true"
            />
          </b-form-group>
        </b-col>
        <!-- Item Dialcode -->
        <b-col xl="2" lg="2" md="4" sm="6">
          <b-form-group
            :label="$t('user.dialCode')"
            :label-for="`admission-phone-dialcode${index}`"
            class="mb-0"
          >
            <my-v-select
                :key="phones[index].countryId"
              :id="`admission-phone-dialcode${index}`"
              v-if="countries"
              :translate="false"
              v-model="phones[index].countryId"
              :concat-label="['title.fa', 'phoneCode']"
              :options="countries.length ? countries : []"
              :multiple="false"
              :searchable="true"
              :filterable="true"
            />
          </b-form-group>
        </b-col>
        <!-- Item PostalCode -->
        <b-col xl="2" lg="3" md="4" sm="6">
          <b-form-group
            :invalid-feedback="
              $t(`validation.${invalidPhone(index)}`, {
                min: $t('11'),
                max: $t('11'),
                field: $t('user.phone'),
              })
            "
            :label="$t('user.phone')"
            :state="v.phones.$each.$iter[index].phone.$dirty ? ((!v.phones.$each.$iter[index].phone.$invalid === false) ? false : null) : null"

            :label-for="`admission-phone-phone${index}`"
            class="mb-0"

          >
            <!-- :state="v.mobiles.$dirty ? !v.mobile.$invalid : null" -->
            <!-- :state="v.mobile.$dirty ? !v.mobile.$invalid : null" -->
            <b-form-input
              @keypress="preventPhoneType($event, index)"
              :aria-describedby="`admission-phone-phone${index}`"
              v-model="phones[index].phone"
              :state="v.phones.$each.$iter[index].phone.$dirty ? ((!v.phones.$each.$iter[index].phone.$invalid === false) ? false : null) : null"
              :id="`admission-phone-phone${index}`"
            />
            <b-form-text
              class="form-text text-muted"
              :id="`admission-phone-phone${index}`"
              ><small>{{ $t("hint.phone") }}</small></b-form-text
            >
          </b-form-group>
        </b-col>

        <!-- Item Internal -->
        <b-col xl="1" lg="2" md="4" sm="6">
          <b-form-group
            :label="$t('user.internal')"
            :label-for="`phone.internal${index}`"
          >
            <!-- :state="v.mobiles.$dirty ? !v.mobile.$invalid : null" -->
            <!-- :state="v.mobile.$dirty ? !v.mobile.$invalid : null" -->
            <b-form-input
              :disabled="phones[index].type == 'home'"
              type="number"
              aria-describedby="admission-phone-internal"
              v-model="phones[index].internal"
              :id="`phone.internal${index}`"
            />
          </b-form-group>
        </b-col>
        <!-- Remove and Add Button -->
        <b-col lg="2" md="4">
          <div class="action-buttons has-margin md">
            <b-button
              v-ripple.400="'rgba(234, 84, 85, 0.15)'"
              variant="white"
              @click="removeItem(index)"
            >
              <b-icon icon="x-circle" variant="danger" scale="2"></b-icon>
            </b-button>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="white"
              @click="repeateAgain"
            >
              <b-icon icon="plus-circle" variant="success" scale="2"></b-icon>
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-form>
  </div>

  <!--
    <template #code>
      {{ codeBasic }}
    </template> -->
</template>

<script>
import BCardCode from "@core/components/b-card-code";
import postalCodeValidation from "@/mixins/validations/postalCode";
// import { required } from "vuelidate/lib/validators";
import { heightTransition } from "@/mixins/ui/transition";
import {
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BButton,
  BFormSelect,
  BFormSelectOption,
  BFormText,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import { mapGetters } from "vuex";
import MyVSelect from "@/components/wrapper/select/MyVSelect";
// import { codeBasic } from "./code";

export default {
  components: {
    MyVSelect,
    BCardCode,
    BForm,
    BRow,
    BCol,
    BButton,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BFormSelectOption,
    BFormText,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      nextTodoId: 2,
    };
  },
  mixins: [postalCodeValidation, heightTransition],
  computed: {
    ...mapGetters({
      types: "user/addressTypes",
      countries: "location/countries",
      // country: "user/country"
    }),
    phones: {
      set(phones) {
        this.$store.commit("user/SET_PHONES", phones);
      },
      get() {
        return this.$store.getters["user/phones"];
      },
    },
  },
  mounted() {
    this.initTrHeight();
    this.phones.forEach((phone, index) => {
      this.$set(phone, "type", "home");
    });
  },
  created() {
    window.addEventListener("resize", this.initTrHeight);
  },
  destroyed() {
    window.removeEventListener("resize", this.initTrHeight);
  },
  props: ["v", "isForeigner"],
  methods: {
    preventPhoneType(value, index) {
      if (this.phones[index].phone.length >= 11) {
        value.preventDefault();
        return;
      }
    },
    invalidPhone(index) {
      var error = "";
      if (!this.v.phones.$each.$iter[index].phone.$dirty) return error;
      // if (!this.v.phones.$each.$iter[index].phone.required) {
      //   error = "required";
      //   return error;
      // }

      if (!this.v.phones.$each.$iter[index].phone.phoneValidation) {
        error = "invalid";
        return error;
      }
      if (!this.v.phones.$each.$iter[index].phone.minLength) {
        error = "min";
        return error;
      }
      if (!this.v.phones.$each.$iter[index].phone.maxLength) {
        error = "max";
        return error;
      }
      return error;
    },
    // phoneInput(index) {
    //   this.v.phones.$each.$iter[index].phone.$touch();
    //   this.$store.commit("validation/SET_VALID", !this.v.phones.$invalid);
    // },
    repeateAgain() {
      this.phones.push({
        // id: (this.nextTodoId += this.nextTodoId),
        phone: "",
        internal: "",
        type: "",
        countryId: "",
      });
      this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight);
      });
    },
    removeItem(index) {
      if (index !== 0) {
        this.phones.splice(index, 1);
        this.trTrimHeight(this.$refs.row[0].offsetHeight);
      }
    },
    initTrHeight() {
      this.trSetHeight(null);
      this.$nextTick(() => {
        this.trSetHeight(this.$refs.form.scrollHeight);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.repeater-form {
  overflow: hidden;
  transition: 0.35s height;
}
</style>
